import * as React from "react";
import { merge, $ } from "glamor";
import { PAPER_HEIGHT } from "./nu-rich-select-cell-editor";
import Typography from "@material-ui/core/Typography";
import { formatMessage } from "lib/globalize-util";

const noAvailableOptionsStyles = merge(
    { display: "flex", justifyContent: "center", minHeight: `${PAPER_HEIGHT}px` },
    $(" .MuiTypography-root", { alignSelf: "center" }),
    $(" .MuiTypography-body1", {
        fontSize: "1.4rem",
    })
);
export const NoAvailableOptions: React.FunctionComponent = () => {
    return (
        <div {...noAvailableOptionsStyles}>
            <Typography>{formatMessage("Nothing to show")}</Typography>
        </div>
    );
};
